<ng-container *ngIf="{ note: noteStore.note$ | async } as state">
  <app-panel *ngIf="!state.note; else noteEl" data-at-note>
    <app-panel-header>
      <div class="flex flex-row justify-between items-center w-full min-w-full h-full min-h-full">
        <div>{{ 'NOTE_MODAL.NOTE' | translate }}</div>
        <button
          mat-stroked-button
          color="accent"
          appSmallButton
          data-at-installation-note-add
          gtm="onOpen"
          gtmAction="Add note modal"
          gtmCategory="notePanel"
          (click)="showNoteModal(state.note)"
        >
          <mat-icon>add</mat-icon>
          <span>{{ 'GENERAL.BUTTON.ADD' | translate }}</span>
        </button>
      </div>
    </app-panel-header>
  </app-panel>

  <ng-template #noteEl>
    <app-panel data-at-note [expandable]="true" [expanded]="true">
      <app-panel-header>
        <div>{{ 'NOTE_MODAL.NOTE' | translate }}</div>
      </app-panel-header>
      <app-panel-content class="note" data-at-installation-note-text>
        {{
          state.note.length > 300 && !showFullNote
            ? state.note.substring(0, 300) + '...'
            : state.note
        }}
      </app-panel-content>
      <app-panel-content class="!flex flex-col gap-[8px] justify-start items-end">
        <button
          *ngIf="state.note.length > 300"
          mat-stroked-button
          color="accent"
          appSmallButton
          [attr.data-at-full-note-button]="showFullNote ? 'hide' : 'show'"
          gtm="onOpen"
          gtmAction="Show/Hide full note"
          gtmCategory="notePanel"
          (click)="toggleShowFullNote()"
        >
          <span>{{
            showFullNote
              ? ('NOTE_MODAL.HIDE_FULL_NOTE' | translate)
              : ('NOTE_MODAL.SHOW_FULL_NOTE' | translate)
          }}</span>
        </button>
        <div class="flex flex-row gap-[8px] justify-end items-center">
          <button
            data-at-installation-note-delete
            mat-icon-button
            class="btn-delete-note"
            appSmallButton
            [viConfirm]="{
              title: 'NOTE_PANEL.DELETE_MODAL.TITLE' | translate,
              content: '',
              cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
              confirmBtn: 'GENERAL.BUTTON.DELETE' | translate
            }"
            gtm="onDelete"
            gtmAction="Note"
            gtmCategory="notePanel"
            (confirm)="deleteNote()"
            (cancel)="cancelDeleteModalConfirmation()"
          >
            <mat-icon>delete</mat-icon>
          </button>
          <button
            mat-stroked-button
            color="accent"
            appSmallButton
            data-at-installation-note-edit
            gtm="onOpen"
            gtmAction="Note modal"
            gtmCategory="notePanel"
            (click)="showNoteModal(state.note)"
          >
            <mat-icon>edit</mat-icon>
            <span>{{ 'GENERAL.BUTTON.EDIT' | translate }}</span>
          </button>
        </div>
      </app-panel-content>
    </app-panel>
  </ng-template>
</ng-container>
